import { CustomerDetails, permissionAllowed } from "@ews/react-data";
import { useNamedRoutes } from "../../../NamedRoutes";

import
{
    useCustomerDetails,
    useModifyCustomerDetails
} from "../../../ReactData/customer";

import { IonAvatar } from "@ionic/react";
import { useMyPermissions } from "../../../Login/LoginProvider";
import SettingsCol from "../../../Settings/SettingsCol/SettingsCol";
import SettingsCheckbox from "../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox";
import SettingsDropFile from "../../../Settings/SettingsComponents/SettingsDropFile/SettingsDropFile";
import SettingsInfo from "../../../Settings/SettingsComponents/SettingsInfo/SettingsInfo";
import logoStyle from "./logoSettings.module.scss";
import { LogoSettingsProps } from "./types";

const LogoSettings: React.FC<LogoSettingsProps> = ({ customer, }) =>
{
    const { params } = useNamedRoutes();
    const { id } = params();

    const logo = useCustomerDetails(customer.id || id!);
    const modifyCustomerDetails = useModifyCustomerDetails();

    const myPermissions = useMyPermissions();
    const allowedToEdit = permissionAllowed(myPermissions.createCustomer || 0);

    function saveCustomerDetails(key: keyof CustomerDetails, value: any)
    {
        if (!customer.id || !(key in logo)) return;
        modifyCustomerDetails(customer.id, { [key]: value } as CustomerDetails);
    }

    return <>
        <SettingsCol>

            <SettingsDropFile
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_LOGO_LABEL"}
                onFile={(formData) =>
                {
                }} />
            <SettingsCheckbox
                disabled={!allowedToEdit}
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_LOGO_ACTIVE_LABEL"}
                checked={logo.useCustomerLogo || false}
                onChange={(checked) => { saveCustomerDetails("useCustomerLogo", checked); }} />

            <SettingsInfo
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_LOGO_INFORMATION"}
                value={""} />
            <SettingsInfo
                text={"COM_FACPMANAGEMENT_CUSTOMER_FIELD_LOGO_PREVIEW"}
                value={logo.customerLogoUrl || ""} >
                {logo.customerLogoUrl ? <div className={logoStyle.img}>
                    <IonAvatar>
                        <img src={logo.customerLogoUrl} alt="" />
                    </IonAvatar>
                </div>
                    :
                    null}
            </SettingsInfo>


        </SettingsCol>
        <SettingsCol>

        </SettingsCol>
        <SettingsCol>

        </SettingsCol>

    </>;
};

export default LogoSettings;